import CheckPermission from '../../../hooks/CheckPermission';
import React, { useState } from 'react'
import { FaPlus, FaSearch } from 'react-icons/fa'
import { Dialog } from 'primereact/dialog'
import { Formik, Form, Field } from 'formik'
import { InputText } from 'primereact/inputtext'
import { InputTextarea } from 'primereact/inputtextarea'
import { Dropdown } from 'primereact/dropdown'
import { Checkbox } from 'primereact/checkbox'
import CustomButton from '../../../shared/CustomButton'

const dummyWards = ['Ward A', 'Ward B', 'Ward C']
const dummyBeds = ['Bed 1', 'Bed 2', 'Bed 3']
const statusOptions = [
  { label: 'Requested', value: 'Requested' },
  { label: 'Approved', value: 'Approved' },
  { label: 'In progress', value: 'In progress' },
  { label: 'Cancelled', value: 'Cancelled' },
  { label: 'Completed', value: 'Completed' }
]
const sexOptions = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'Other' }
]
const priorityOptions = [
  { label: 'High', value: 'High' },
  { label: 'Medium', value: 'Medium' },
  { label: 'Low', value: 'Low' }
]

const TransferTab = ({ patient }) => {
  const { hasPermission } = CheckPermission();
  const [searchTerm, setSearchTerm] = useState('')
  const [showAddDialog, setShowAddDialog] = useState(false)
  const [showAddPatient, setShowAddPatient] = useState(false)
  const [transfers, setTransfers] = useState([])
  const [selectedTransfer, setSelectedTransfer] = useState(null)
  const [showSearchResults, setShowSearchResults] = useState(false)
  const initialForm = {
    date: '',
    patient: patient?.patient_id || '',
    patientMobile: patient?.contact || '',
    patientFileNo: patient?.file_no || '',
    patientDOB: patient?.dob || '',
    patientSex: patient?.gender || '',
    fromWard: '',
    fromBed: '',
    destWard: '',
    destBed: '',
    status: '',
    reason: '',
    priority: '',
    infective: false,
    mobilityAssistance: false,
    fallRisk: false,
    covid19: false,
    confused: false,
    visualSupervision: false,
    endOfLifePathway: false,
    transferRequirement: '',
    transferTime: '',
    dateScheduled: '',
    approvedDate: '',
    handoverInfo: '',
    supportiveNotification: ''
  }
  // Filtered transfers for search
  const filteredTransfers =
    searchTerm.trim() === ''
      ? transfers
      : transfers.filter(t =>
          t.patient.toLowerCase().includes(searchTerm.toLowerCase())
        )

  // Formik form UI (reusable for dialog and page)
  const renderForm = (isDialog = false, formInitial = initialForm) => (
    <Formik
      initialValues={formInitial}
      enableReinitialize
      onSubmit={(values, { resetForm }) => {
        let payload
        if (values?.patient == '') {
          payload = {
            ...values,
            patient: patient?.patient_id,
            patientMobile: patient?.contact,
            patientFileNo: patient?.file_no,
            patientDOB: patient?.dob,
            patientSex: patient?.gender
          }
        }
        if (isDialog) {
          setTransfers(prev => [...prev, { ...payload, id: Date.now() }])
          setShowAddDialog(false)
        } else {
          setTransfers(prev =>
            prev.map(t => (t.id === selectedTransfer.id ? { ...payload } : t))
          )
          alert('Transfer updated (dummy action)')
        }
        resetForm()
      }}
    >
      {({ values, setFieldValue, resetForm }) => (
        <Form className='space-y-4'>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Date
              </label>
              <Field name='date'>
                {({ field }) => (
                  <InputText {...field} type='date' className='w-full' />
                )}
              </Field>
            </div>
            {/* <div className='flex items-center gap-2'>
              <div className='flex-1'>
                <label className='block text-sm font-medium text-gray-700 mb-1'>
                  Patient
                </label>
                <InputText
                  value={values.patient}
                  className='w-full bg-gray-100'
                  disabled
                />
              </div>
              <CustomButton
                type='button'
                icon={<FaPlus className='text-blue-600' />}
                className='ml-2 p-button-sm p-button-info'
                onClick={() => setShowAddPatient(true)}
                tooltip='Add Patient'
              />
            </div> */}
            {/* <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Patient Mobile
              </label>
              <Field name='patientMobile'>
                {({ field }) => <InputText {...field} className='w-full' />}
              </Field>
            </div> */}
            {/* <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Patient File No.
              </label>
              <Field name='patientFileNo'>
                {({ field }) => <InputText {...field} className='w-full' />}
              </Field>
            </div> */}
            {/* <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Patient DOB
              </label>
              <Field name='patientDOB'>
                {({ field }) => (
                  <InputText {...field} type='date' className='w-full' />
                )}
              </Field>
            </div> */}
            {/* <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Patient Sex
              </label>
              <Dropdown
                className='w-full'
                name='patientSex'
                value={values.patientSex}
                options={sexOptions}
                onChange={e => setFieldValue('patientSex', e.value)}
                placeholder='Select'
              />
            </div> */}
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                From Ward
              </label>
              <Dropdown
                className='w-full'
                name='fromWard'
                value={values.fromWard}
                options={dummyWards.map(w => ({ label: w, value: w }))}
                onChange={e => setFieldValue('fromWard', e.value)}
                placeholder='Select'
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                From Bed
              </label>
              <Dropdown
                className='w-full'
                name='fromBed'
                value={values.fromBed}
                options={dummyBeds.map(b => ({ label: b, value: b }))}
                onChange={e => setFieldValue('fromBed', e.value)}
                placeholder='Select'
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Destination Ward
              </label>
              <Dropdown
                className='w-full'
                name='destWard'
                value={values.destWard}
                options={dummyWards.map(w => ({ label: w, value: w }))}
                onChange={e => setFieldValue('destWard', e.value)}
                placeholder='Select'
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Destination Bed
              </label>
              <Dropdown
                className='w-full'
                name='destBed'
                value={values.destBed}
                options={dummyBeds.map(b => ({ label: b, value: b }))}
                onChange={e => setFieldValue('destBed', e.value)}
                placeholder='Select'
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Status
              </label>
              <Dropdown
                className='w-full'
                name='status'
                value={values.status}
                options={statusOptions}
                onChange={e => setFieldValue('status', e.value)}
                placeholder='Select'
              />
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Priority
              </label>
              <Dropdown
                className='w-full'
                name='priority'
                value={values.priority}
                options={priorityOptions}
                onChange={e => setFieldValue('priority', e.value)}
                placeholder='Select'
              />
            </div>
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Reason
            </label>
            <Field name='reason'>
              {({ field }) => (
                <InputTextarea {...field} rows={2} className='w-full' />
              )}
            </Field>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            {Object.entries({
              infective: 'Infective',
              mobilityAssistance: 'Mobility Assistance',
              fallRisk: 'Fall Risk',
              covid19: 'Covid 19',
              confused: 'Confused',
              visualSupervision: 'Visual Supervision',
              endOfLifePathway: 'End of Life Pathway'
            }).map(([name, label]) => (
              <div key={name} className='flex items-center gap-2'>
                <Checkbox
                  inputId={name}
                  name={name}
                  checked={values[name]}
                  onChange={e => setFieldValue(name, e.checked)}
                />
                <label htmlFor={name}>{label}</label>
              </div>
            ))}
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Transfer Requirement
            </label>
            <Field name='transferRequirement'>
              {({ field }) => <InputText {...field} className='w-full' />}
            </Field>
          </div>
          <div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Transfer Time
              </label>
              <Field name='transferTime'>
                {({ field }) => (
                  <InputText {...field} type='time' className='w-full' />
                )}
              </Field>
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Date Scheduled
              </label>
              <Field name='dateScheduled'>
                {({ field }) => (
                  <InputText {...field} type='date' className='w-full' />
                )}
              </Field>
            </div>
            <div>
              <label className='block text-sm font-medium text-gray-700 mb-1'>
                Approved Date
              </label>
              <Field name='approvedDate'>
                {({ field }) => (
                  <InputText {...field} type='date' className='w-full' />
                )}
              </Field>
            </div>
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Handover Information
            </label>
            <Field name='handoverInfo'>
              {({ field }) => (
                <InputTextarea {...field} rows={2} className='w-full' />
              )}
            </Field>
          </div>
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-1'>
              Supportive Notification
            </label>
            <Field name='supportiveNotification'>
              {({ field }) => (
                <InputTextarea {...field} rows={2} className='w-full' />
              )}
            </Field>
          </div>
          <div className='flex justify-end gap-3 pt-4 border-t border-gray-200'>
            <CustomButton
              type='button'
              label='Cancel'
              className='p-button-secondary'
              onClick={() => {
                resetForm()
                if (isDialog) setShowAddDialog(false)
              }}
            />
            {hasPermission('patientTransfer', 'create') && (
            <CustomButton
              type='submit'
              label={isDialog ? 'Submit' : 'Save'}
              className='p-button-primary'
            />
          )}
          </div>
        </Form>
      )}
    </Formik>
  )

  return (
    <div className='h-full flex flex-col'>
      <div className='p-6 pb-4 flex-shrink-0'>
        <h2 className='text-2xl font-bold'>Transfer</h2>
      </div>
      <div className='flex-1 px-6 pb-6 overflow-y-auto max-h-[calc(100vh-250px)]'>
        {/* Search bar and plus icon */}
        <div className='flex items-center gap-2 mb-6'>
          <div className='relative flex-1'>
            <InputText
              className='w-full pl-8'
              placeholder='Search transferred...'
              value={searchTerm}
              onChange={e => {
                setSearchTerm(e.target.value)
                setShowSearchResults(true)
              }}
              onFocus={() => setShowSearchResults(true)}
            />
            <FaSearch className='absolute left-2 top-3 text-gray-400' />
            {/* Search results dropdown */}
            {showSearchResults && filteredTransfers.length > 0 && (
              <div className='absolute z-10 bg-white border border-gray-200 rounded shadow w-full mt-1 max-h-60 overflow-y-auto'>
                {filteredTransfers.map(t => (
                  <div
                    key={t.id}
                    className='px-4 py-2 hover:bg-blue-50 cursor-pointer'
                    onClick={() => {
                      setSelectedTransfer(t)
                      setShowSearchResults(false)
                    }}
                  >
                    {t.patient} - {t.date}
                  </div>
                ))}
              </div>
            )}
          </div>
          <CustomButton
            type='button'
            icon={<FaPlus className='text-blue-600' />}
            className='p-button-info'
            onClick={() => {
              setShowAddDialog(true)
            }}
            tooltip='Add Transfer'
          />
        </div>
        {/* Add Transfer Dialog using PrimeReact Dialog */}
        <Dialog
          header='Add Transfer'
          visible={showAddDialog}
          style={{ width: '60vw', maxWidth: 700 }}
          onHide={() => setShowAddDialog(false)}
          closable
          draggable={false}
          resizable={false}
          className='p-fluid'
        >
          {renderForm(true, { ...initialForm, patient: patient?.name || '' })}
        </Dialog>
        {/* Add Patient Dialog (dummy, reuse actual dialog in real app) */}
        {showAddPatient && (
          <div className='fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50'>
            <div className='bg-white p-6 rounded shadow-lg w-96'>
              <h3 className='text-lg font-bold mb-2'>Add Patient</h3>
              <p className='mb-4 text-gray-600'>
                (Dialog placeholder. Reuse AddPatientDialog from ward
                management.)
              </p>
              <CustomButton
                className='p-button-primary'
                label='Close'
                onClick={() => setShowAddPatient(false)}
              />
            </div>
          </div>
        )}
        {/* Transfer Form (when selected) */}
        {selectedTransfer && (
          <div className='bg-gray-50 rounded-lg p-6 mt-6'>
            <h3 className='text-lg font-bold mb-2'>Edit Transfer</h3>
            {renderForm(false, selectedTransfer)}
          </div>
        )}
      </div>
    </div>
  )
}

export default TransferTab
